export default "__VITE_ASSET__CIgg$xzp__"